export default `/* Ids kpi Component */
:host {
  display: inline-flex;
}

.ids-kpi {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  box-sizing: border-box;
  color: var(--ids-kpi-color-text-default);
  display: flex;
  align-items: center;
  height: var(--ids-kpi-height);
  font-family: var(--ids-font-family-default), var(--ids-font-family-system-sans);
  max-height: var(--ids-kpi-height);
  max-width: var(--ids-kpi-width);
  position: relative;
  pointer-events: none;
  width: var(--ids-kpi-width);
}
.ids-kpi ids-text {
  width: var(--ids-kpi-width);
  min-height: var(--ids-kpi-min-label-height);
}
.ids-kpi ids-text[tooltip] {
  pointer-events: auto;
  cursor: default;
}
.ids-kpi .main-label {
  color: var(--ids-kpi-color-text-secondary);
}
.ids-kpi .subtitle {
  color: var(--ids-kpi-color-text-tertiary);
  margin-block-start: 1px;
  min-height: var(--ids-kpi-min-subtitle-height);
}
.ids-kpi .trend-container {
  height: var(--ids-kpi-color-trend-container-height);
  width: 100%;
}
.ids-kpi .trend-container:not(.show-all) {
  margin-block-end: 8px;
}
.ids-kpi .trend-container.show-all {
  display: inline-flex;
  flex-direction: row-reverse;
  gap: 8px;
}
.ids-kpi.compact {
  --ids-kpi-height: 115px;
}
.ids-kpi.compact .trend-container {
  height: var(--ids-kpi-color-trend-container-height);
  width: 100%;
}
.ids-kpi.compact .trend-container:not(.show-all) {
  margin-block-end: 0;
}
.ids-kpi.compact .kpi-label {
  color: var(--ids-kpi-color-text-default);
  margin-block-end: 0;
}
.ids-kpi .main-icon {
  position: absolute;
  margin-block-start: 5px;
  margin-inline-start: 1px;
}
.ids-kpi .main-icon.show-always {
  position: static;
}
.ids-kpi .trend-label {
  font-weight: var(--ids-font-weight-semibold);
  font-size: var(--ids-kpi-trend-label-font-size);
  position: absolute;
  margin-block-start: 8px;
  margin-inline-start: 1px;
  text-overflow: ellipsis;
  overflow: hidden;
  width: var(--ids-kpi-width);
}
.ids-kpi .trend-label.is-positive {
  color: var(--ids-kpi-positive-color-text);
}
.ids-kpi .trend-label.is-negative {
  color: var(--ids-kpi-negative-color-text);
}
.ids-kpi .trend-label.show-always {
  position: static;
}
.ids-kpi .trend-label.show-always svg {
  margin-inline-start: 2px;
}
.ids-kpi .trend-label svg {
  padding-inline-start: 6px;
}
.ids-kpi .kpi-label {
  color: var(--ids-kpi-color-text-default);
  margin-block-end: 4px;
}
.ids-kpi > ids-layout-flex {
  width: 100%;
  height: auto;
  align-items: flex-start;
}
.ids-kpi ids-layout-flex {
  width: 100%;
}
.ids-kpi.colspan {
  --ids-kpi-width: var(--ids-kpi-width-double);
}
.ids-kpi.show-all ids-layout-flex ids-layout-flex {
  height: 34px;
  margin-block-end: 2px;
}
.ids-kpi.show-all ids-layout-flex ids-layout-flex + ids-layout-flex-item {
  height: 50px;
  margin-block-end: 4px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
